import React, { useEffect, useState } from 'react';
import {
  Button, Col, Label, Row
} from 'reactstrap';
import Services from '../services';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../RendelesTooltips';

const BeallitasContent = () => {
  const [ervenyesseg, setErvenyesseg] = useState();
  const [szallitasi, setSzallitasi] = useState();
  const [fizetesi, setFizetesi] = useState();
  const [editMode, setEditMode] = useState(false);
  
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);

  const regexValidator = ['^[0-9]+$', 'Csak egész szám írható be!'];

  const listBeallitas = async () => {
    try {
      const json = await Services.listBeallitas();
      // String-gé van konvertálva, mert a megengedett 0 érték falsy-nak van értelmezve, és felületen betöltéskor üres lesz a mező
      setErvenyesseg(json.ervenyesseg + '');
      setSzallitasi(json.szallitasi + '');
      setFizetesi(json.fizetesi + '');
    } catch (ex) {}
  };

  useEffect(() => {
    listBeallitas();
  }, []);

  const handleOkClick = async () => {
    if (editMode) {
      setSaveButtonLoading(true);
      try {
        await Services.editBeallitas({ ervenyesseg, szallitasi, fizetesi });
        listBeallitas();
        setEditMode(false);
      } catch (ex) {}
      setSaveButtonLoading(false);
    } else {
      setEditMode(true);
    }
  };

  const handleCancelClick = () => {
    setEditMode(false);
    listBeallitas();
  };

  return (
    <>
      <RFForm onSubmit={handleOkClick}>
        <Row style={{ paddingRight: 10 }}>
          <Col md="3">
            <RFField
              name="e"
              label="Érvényességi idő (nap): "
              tooltip={<CustomTooltip text={getTooltip('ervenyessegiido')} id="ervenyessegiidoTT" />}
              forcedValue={ervenyesseg}
              value={ervenyesseg}
              onChange={e => setErvenyesseg(e.target.value)}
              regex={regexValidator}
              disabled={!editMode}
              required
            />
          </Col>
          <Col md="3">
            <RFField
              name="sz"
              label="Szállítási határidő (nap): "
              tooltip={<CustomTooltip text={getTooltip('szallitasihatarido')} id="szallitasihataridoTT" />}
              forcedValue={szallitasi}
              value={ervenyesseg}
              onChange={e => setSzallitasi(e.target.value)}
              regex={regexValidator}
              disabled={!editMode}
              required
            />
          </Col>
          <Col md="3">
            <RFField
              name="f"
              label="Fizetési határidő (nap): "
              tooltip={<CustomTooltip text={getTooltip('fizetesihatarido')} id="fizetesihataridoTT" />}
              forcedValue={fizetesi}
              value={ervenyesseg}
              onChange={e => setFizetesi(e.target.value)}
              regex={regexValidator}
              disabled={!editMode}
              required
            />
          </Col>
          <div className='w-100' />
          <Col xs="auto">
            <ProgressButton loading={saveButtonLoading} className='mr-1' type="submit" color="success">{editMode ? 'Mentés' : 'Módosítás'}</ProgressButton>
            { editMode && <Button type="button" onClick={handleCancelClick}>Mégsem</Button>}
          </Col>
        </Row>
      </RFForm>
    </>
  );
};

export default BeallitasContent;
